export const LOGIN_SUBMIT = 'LOGIN_SUBMIT';
export const REQUEST_API = 'REQUEST_API';
export const RECEIVE_API_SUCCESS = 'RECEIVE_API_SUCCESS';
export const RECEIVE_API_ERROR = 'RECEIVE_API_ERROR';
export const ADD_EXPENSE = 'ADD_EXPENSE';
export const TOTAL_SUM = 'TOTAL_SUM';
export const DELETE_BTN = 'DELETE_BTN';
export const UPDATE_SUM = 'UPDATE_SUM';
